import Controller from '@ember/controller'
import { tracked } from '@glimmer/tracking'

export default class ReadingEggspressDashboardStudentAssignmentsIndexController extends Controller {
  queryParams = ['pageNumber', 'perPage', 'sort']

  @tracked pageNumber = 1

  @tracked perPage = 20

  @tracked sort = '-created_at'
}

declare module '@ember/controller' {
  interface Registry {
    'reporting/ui-scope/rex/dashboard/student/assignments/index': ReadingEggspressDashboardStudentAssignmentsIndexController
  }
}
